import * as React from 'react';
import { useTicks } from "../hooks/useTicks.js";
import { GridLine } from "./styledComponents.js";
import { useChartContext } from "../context/ChartProvider/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
export function ChartsGridVertical(props) {
  const {
    instance
  } = useChartContext();
  const {
    axis,
    start,
    end,
    classes
  } = props;
  const {
    scale,
    tickNumber,
    tickInterval,
    tickSpacing
  } = axis;
  const xTicks = useTicks({
    scale,
    tickNumber,
    tickInterval,
    tickSpacing,
    direction: 'x',
    ordinalTimeTicks: 'ordinalTimeTicks' in axis ? axis.ordinalTimeTicks : undefined
  });
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: xTicks.map(({
      value,
      offset
    }) => !instance.isXInside(offset) ? null : /*#__PURE__*/_jsx(GridLine, {
      y1: start,
      y2: end,
      x1: offset,
      x2: offset,
      className: classes.verticalLine
    }, `vertical-${value?.getTime?.() ?? value}`))
  });
}